import { __ } from "@wordpress/i18n";
import { Link, useLocation } from "react-router-dom";
import useAdminMenuHighlight from '../hooks/useAdminMenuHighlight';
import MegaMenu from "../layouts/MegaMenu/MegaMenu";

// Import all the pages
import LoginActionLogin from "../pages/LoginActionLogin";
import LoginActionLoginAutomations from "../pages/LoginActionLoginAutomations";
import LoginActionLoginSettings from "../pages/LoginActionLoginSettings";
import LoginTemporaryLoginCreate from "../pages/LoginTemporaryLoginCreate";
import LoginTemporaryLoginExpress from "../pages/LoginTemporaryLoginExpress";
import LoginTemporaryLoginSettings from "../pages/LoginTemporaryLoginSettings";
import MoreReset from "../pages/MoreReset";
import MoreStatus from "../pages/MoreStatus";
import OtherPlugin from "../pages/other-plugins/index";
import PasskeyActivityLog from "../pages/Passkeys/ActivityLog";
import PasskeyAdvanced from "../pages/Passkeys/Advanced";
import PasskeyDisplay from "../pages/Passkeys/Display";
import PasskeyGeneralSettings from "../pages/Passkeys/GeneralSettings";
import PasskeysOverview from "../pages/Passkeys/Overview";
import Passkeys from "../pages/Passkeys/Passkeys";
import RestrictionsSettings from "../pages/RestrictionsSettings";
import Security2faAuthentication from "../pages/Security2faAuthentication";
import Security2faList from "../pages/Security2faList";
import SecurityAddressBlacklist from "../pages/SecurityAddressBlacklist";
import SecurityAdminPassword from "../pages/SecurityAdminPassword";
import SecurityAPIPrivacy from "../pages/SecurityAPIPrivacy";
import SecurityComments from "../pages/SecurityComments";
import SecurityDisableRightClick from "../pages/SecurityDisableRightClick";
import SecurityEmailBlacklist from "../pages/SecurityEmailBlacklist";
import SecurityErrorNotification from "../pages/SecurityErrorNotification";
import SecurityLoginSecurity from "../pages/SecurityLoginSecurity";
import SecurityPasswordPolicies from "../pages/SecurityPasswordPolicies";
import SecurityRecaptcha from "../pages/SecurityRecaptcha";
import SecurityRecommendations from "../pages/SecurityRecommendations";
import SecuritySaltChange from "../pages/SecuritySaltChange";
import SecurityUpdates from "../pages/SecurityUpdates";
import SiteHealthInfo from "../pages/SiteHealthInfo/SiteHealthInfo";
import MoreExtra from "./MoreExtra";
import SecurityCloudflareTurnstile from "./SecurityCloudflareTurnstile/SecurityCloudflareTurnstile";
import SecurityLoginLimit from "./SecurityLoginLimit";
import SecurityInjectionGuard from "../pages/SecurityInjectionGuard";
import SecurityInjectionGuardQueryStrings from "../pages/SecurityInjectionGuardQueryStrings";
import SecurityInjectionGuardUserAgents from "../pages/SecurityInjectionGuardUserAgents";
import SecurityInjectionGuardRequestsLog from "./SecurityInjectionGuardRequestsLog";
import ImportExport from "./ImportExport";

const Settings = () => {
  useAdminMenuHighlight(); 
  const location = useLocation();
  const pathname = location.pathname;
  
  // Component mapping - associates paths with their components
  const ROUTE_COMPONENT_MAP = { 
    // Login pages
    "/login": LoginActionLoginSettings,

    "/login/temporary-login": LoginTemporaryLoginCreate,
    "/login/temporary-login/create": LoginTemporaryLoginCreate,
    "/login/temporary-login/settings": LoginTemporaryLoginSettings,
    
    "/login/active-logins": LoginActionLoginSettings,
    "/login/active-logins/settings": LoginActionLoginSettings,
    "/login/active-logins/current-sessions": LoginActionLogin,
    "/login/active-logins/automations": LoginActionLoginAutomations,

    "/login/express-login": LoginTemporaryLoginExpress,
    "/login/express-login/settings": LoginTemporaryLoginExpress,


    "/login/login-security": SecurityLoginSecurity,
    "/login/login-security/login-url": SecurityLoginSecurity,

    "/login/2fa": Security2faAuthentication,
    "/login/2fa/settings": Security2faAuthentication,
    "/login/2fa/user-list": Security2faList,

    //passkeys
    "/login/passkeys/overview": PasskeysOverview,
    "/login/passkeys/passkeys": Passkeys,
    "/login/passkeys/activity-log": PasskeyActivityLog,
    "/login/passkeys/settings": PasskeyGeneralSettings,
    "/login/passkeys/display": PasskeyDisplay,
    "/login/passkeys/advanced": PasskeyAdvanced,
    

    // Security pages
    "/security": SecurityRecaptcha,
    "/security/site-security": SecurityRecaptcha,
    "/security/site-security/re-captcha": SecurityRecaptcha,
    "/security/site-security/cloudflare-turnstile": SecurityCloudflareTurnstile,
    "/security/site-security/login-limit": SecurityLoginLimit,
    "/security/salt-change": SecuritySaltChange,
    "/security/salt-change/settings": SecuritySaltChange,

    "/security/data-security": SecurityDisableRightClick,
    "/security/data-security/disable-right-click": SecurityDisableRightClick,

    "/security/blacklist-manager": SecurityEmailBlacklist,
    "/security/blacklist-manager/email-blacklist": SecurityEmailBlacklist,
    "/security/blacklist-manager/address-blacklist": SecurityAddressBlacklist,


    "/security/privacy-manager": SecurityAPIPrivacy,
    "/security/privacy-manager/api-privacy": SecurityAPIPrivacy,

    "/security/update-manager": SecurityUpdates,
    "/security/recommendations": SecurityRecommendations,
    "/security/injection_guard": SecurityInjectionGuard,
    "/security/injection_guard/overview": SecurityInjectionGuard,
    "/security/injection_guard/requests_log": SecurityInjectionGuardRequestsLog,
    "/security/injection_guard/query_strings": SecurityInjectionGuardQueryStrings,
    "/security/injection_guard/user_agents": SecurityInjectionGuardUserAgents,

    // Restrictions pages
    "/restrictions": RestrictionsSettings,
    "/restrictions/ip-restrictions": RestrictionsSettings,
    "/restrictions/ip-restrictions/settings": RestrictionsSettings,

    "/login/login-security/password-policies": SecurityPasswordPolicies,
    "/login/login-security/use-admin-password": SecurityAdminPassword,
  
  
    // More pages
    "/more": SiteHealthInfo,
    "/more/site-health-info": SiteHealthInfo,
    "/more/comments-cleaner": SecurityComments,
    "/more/error-notification": SecurityErrorNotification,
    "/more/extra": MoreExtra,
    "/more/import-export": ImportExport,
    "/more/log/status": MoreStatus,
    // "/other-plugin": OtherPlugin,
  };
  
  
  const renderContent = () => {
    // Look up the component for the current path
    const Component = ROUTE_COMPONENT_MAP[pathname];
    
    // If a component is found, render it, otherwise show SettingsNotFound
    return Component ? <Component /> : <SettingsNotFound />;
  };

  return (
    <>
      <div className="row">
        <div className="col-3" style={{ width:"20%" }}>
          <MegaMenu />
        </div>
        <div className="col-9" style={{ width:"80%" }}>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

// Not found component for settings
const SettingsNotFound = () => (
  <div>
    <h2>{__("Setting Not Found", "ultimate-security")}</h2>
    <p>{__("The setting you are looking for does not exist.", "ultimate-security")}</p>
    <Link to="/">{__("Go back to Dashboard", "ultimate-security")}</Link>
  </div>
);

export default Settings;